<template>
  <multipane class="custom-resizer" layout="horizontal" @paneResize="onResized">
    <v-layout row wrap pt-1>
      <v-flex sm12 class="pane">
        <v-layout class="top-container" style="flex-direction: column; flex-wrap: nowrap; min-height: 0;"
          @mousedown.stop>
          <multipane class="inner-multipane" layout="vertical"
            style="flex: 1 1 auto; width: 100%; min-height: 0; overflow: hidden;">
            <div class="pane flex-pane pr-1" v-if="
              isInvAvailable &&
              parameterNameMap['inverter'] &&
              Object.keys(parameterNameMap['inverter']).length > 0
            " style="width: 45%; min-width: 300px;">
              <InverterDataTable
                :nameMap="deviceNameMap['inverter']" :parameter="invParameter"
                :parameterNameMap="parameterNameMap['inverter']" :cardHeight="invHeight" :tableHeight="invTableHeight" />
            </div>

            <multipane-resizer
              title="Drag to resize horizontally"
              v-if="
              isInvAvailable && parameterNameMap['inverter'] && Object.keys(parameterNameMap['inverter']).length > 0 &&
              (isEmAvailable || isMfmAvailable)
            " />

            <div v-if="isEmAvailable || isMfmAvailable" class="pane flex-pane pr-1"
              :style="{ width: (isInvAvailable && parameterNameMap['inverter'] && Object.keys(parameterNameMap['inverter']).length > 0) ? '25%' : '70%', minWidth: '300px' }">
              <v-layout column>
                <v-flex v-if="
                  isEmAvailable &&
                  parameterNameMap['energy meter'] &&
                  Object.keys(parameterNameMap['energy meter']).length > 0">
                  <EmDataTable :nameMap="deviceNameMap['energy meter']" :parameter="emParameter"
                    :parameterNameMap="parameterNameMap['energy meter']" :cardHeight="meterHeight"
                    :tableHeight="emMfmTableHeight" />
                </v-flex>
                <v-flex v-if="
                  isMfmAvailable &&
                  parameterNameMap['mfm'] &&
                  Object.keys(parameterNameMap['mfm']).length > 0
                ">
                  <MfmDataTable :nameMap="deviceNameMap['mfm']" :parameter="mfmParameter"
                    :parameterNameMap="parameterNameMap['mfm']" :cardHeight="meterHeight"
                    :tableHeight="emMfmTableHeight" />
                </v-flex>
              </v-layout>
            </div>

            <multipane-resizer
              title="Drag to resize horizontally"
              v-if="
              isInvAvailable || isEmAvailable || isMfmAvailable
            " />

            <div class="pane flex-pane pl-1" style="flex-grow: 1; min-width: 250px;">
              <ComputedDataCards class="mb-1" v-if="isComputedCardAvailable" />
              <div class="mb-1" v-if="showWeatherStation">
                <WsData :nameMap="deviceNameMap['weather station']" :parameter="wsParameter"
                  :parameterNameMap="parameterNameMap['weather station']" :cardHeight="wsHeight" :tableHeight="wsTableHeight" />
              </div>
              <div class="mb-1" v-if="!isWsAvailable && isScbAvailable &&
                parameterNameMap['scb'] &&
                Object.keys(parameterNameMap['scb']).length > 0 && Object.keys(deviceNameMap).length > 0">
                <ScbDataTable 
                  :nameMap="deviceNameMap['scb']" :parameter="scbParameter" :parameterNameMap="parameterNameMap['scb']"
                  :status="statusObject['scb']" :cardHeight="wsHeight" :tableHeight="wsTableHeight" />
              </div>
              <StatusCards />
            </div>
          </multipane>
        </v-layout>
        <multipane-resizer title="Drag to resize vertically" v-if="isWsAvailable && isScbAvailable" class="horizontal-resizer" />
      </v-flex>
      <v-flex pa-0 sm12 v-if="showWeatherStation && isScbAvailable &&
        parameterNameMap['scb'] &&
        Object.keys(parameterNameMap['scb']).length > 0" class="pane pt-1">
        <ScbDataTable v-if="Object.keys(deviceNameMap).length > 0" :nameMap="deviceNameMap['scb']"
          :parameter="scbParameter" :parameterNameMap="parameterNameMap['scb']" :status="scbStatus"
          :cardHeight="scbHeight" />
      </v-flex>
    </v-layout>
  </multipane>
</template>

<script>
import _ from "lodash";
import { reactive, toRefs, onMounted, watch } from 'vue';
import { Multipane, MultipaneResizer } from 'vue-multipane';
import LiveDb from "@/services/LiveDb";
import {
  mapGettersMixin
} from "@/util/mixin/index";
import {
  mapGetters,
} from "vuex";
import store from '@/store/index'
import InverterDataTable from "@/components/live-dash/DeviceTable/InverterDataTable";
import ScbDataTable from "@/components/live-dash/DeviceTable/ScbDataTable";
import EmDataTable from "@/components/live-dash/DeviceTable/EmDataTable";
import MfmDataTable from "@/components/live-dash/DeviceTable/MfmDataTable";
import WsData from "@/components/live-dash/DeviceTable/WsDataTable";
import StatusCards from "@/components/live-dash/SubComponent/StatusCards";
import ComputedDataCards from "@/components/live-dash/SubComponent/ComputedDataCards";

export default {
  mixins: [mapGettersMixin],
  components: {
    Multipane,
    MultipaneResizer,
    InverterDataTable,
    MfmDataTable,
    EmDataTable,
    StatusCards,
    ComputedDataCards,
    WsData,
    ScbDataTable,
  },
  data() {
    return {
      parameterNameMap: {},
      deviceNameMap: {},
      deviceMapRequestId: 0
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getRules"]),
    availableDeviceList() {
      const accessConfig = this.getRules(["rule", "access_config"]);
      return accessConfig && accessConfig["live_device"] ?
        Object.keys(accessConfig["live_device"]) :
        [];
    },
    isComputedCardAvailable() {
      const accessConfig = this.getRules(["rule", "access_config"]);
      if (accessConfig && accessConfig["live_device"]) {
        return this.availableDeviceList.some((el) => {
          return accessConfig["live_device"][el].length > 0;
        });
      }
      return false;
    },
    parameterObject() {
      const compConfig = this.getRules(["rule", "comp_config"]);
      return compConfig &&
        compConfig["live_monitoring"] &&
        !_.isEmpty(compConfig["live_monitoring"]) ?
        compConfig["live_monitoring"].options.parameters :
        {};
    },
    statusObject() {
      const compConfig = this.getRules(["rule", "comp_config"]);
      return compConfig &&
        compConfig["live_monitoring"] &&
        !_.isEmpty(compConfig["live_monitoring"]) && compConfig["live_monitoring"].options.status ?
        compConfig["live_monitoring"].options.status :
        {};
    },
    scbStatus() {
      return !_.isEmpty(this.statusObject) && this.statusObject['scb'] ? this.statusObject['scb'] : {}
    },
    isEmAvailable() {
      return this.availableDeviceList.includes("Energy Meter");
    },
    isMfmAvailable() {
      return this.availableDeviceList.includes("MFM");
    },
    isWsAvailable() {
      return this.availableDeviceList.includes("Weather Station");
    },
    isInvAvailable() {
      return this.availableDeviceList.includes("Inverter");
    },
    isScbAvailable() {
      return this.availableDeviceList.includes("SCB");
    },
    emMfmFlexClass() {
      // Check for em and mfm
      return this.isEmAvailable || this.isMfmAvailable ? "md7" : "md12";
    },
    invFlexClass() {
      return this.isInvAvailable ? "md5" : "md12";
    },
    invParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["inverter"] :
        [];
    },
    mfmParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["mfm"] :
        [];
    },
    emParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["energy meter"] :
        [];
    },
    wsParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["weather station"] :
        [];
    },
    scbParameter() {
      return !_.isEmpty(this.parameterObject) ?
        this.parameterObject["scb"] :
        [];
    },
    showWeatherStation() {
      return (
        this.isWsAvailable &&
        this.parameterNameMap["weather station"] &&
        Object.keys(this.parameterNameMap["weather station"]).length > 0
      );
    },
  },
  setup() {
    const state = reactive({
      invHeight: '684px',
      invTableHeight: 'calc(684px - 53px)',
      wsHeight: '684px',
      wsTableHeight: 'calc(684px - 53px)',
      scbHeight: '24vh',
      meterHeight: '248px',
      emMfmTableHeight: 'calc(248px - 53px)',
      deviceList: []
    });
    onMounted(() => {
      const accessConfig = store.getters.getRules(["rule", "access_config"])
      state.deviceList = accessConfig && accessConfig["live_device"] ?
        Object.keys(accessConfig["live_device"]) :
        [];
      if (state.deviceList.includes("SCB")) {
        state.meterHeight = state.deviceList.includes("Energy Meter") &&
          state.deviceList.includes("MFM") ? '248px' : '502px'
        state.invHeight = '502px'
      } else {
        state.meterHeight = state.deviceList.includes("Energy Meter") &&
          state.deviceList.includes("MFM") ? '367px' : '734px'
        state.invHeight = '734px'
      }
      state.wsHeight = `calc(${state.invHeight} - 136px)`
      state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
      state.invTableHeight = `calc(${state.invHeight} - 53px)`
      state.wsTableHeight = `calc(${state.wsHeight} - 53px)`
    });
    
    const onResized = (pane, container, size) => {
      state.meterHeight = state.deviceList.includes("Energy Meter") &&
            state.deviceList.includes("MFM") ? 
              `calc((${size} / 2) - 10px)` : `calc(${size} - 10px)`
      state.invHeight = `calc(${size} - 10px)`
      state.wsHeight = `calc(${state.invHeight} - 136px)`
      state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
      state.invTableHeight = `calc(${state.invHeight} - 53px)`
      state.wsTableHeight = `calc(${state.wsHeight} - 53px)`
      state.scbHeight = `calc(100vh - ${size} - 280px)`
    };

    watch(
      () =>  store.getters.getSelectedPlantId,
      () => {
        const accessConfig = store.getters.getRules(["rule", "access_config"])
        state.deviceList = accessConfig && accessConfig["live_device"] ?
          Object.keys(accessConfig["live_device"]) :
          [];
        if (state.deviceList.includes("SCB")) {
          state.meterHeight = state.deviceList.includes("Energy Meter") &&
            state.deviceList.includes("MFM") ? '248px' : '502px'
          state.invHeight = '502px'
        } else {
          state.meterHeight = state.deviceList.includes("Energy Meter") &&
            state.deviceList.includes("MFM") ? '367px' : '734px'
          state.invHeight = '734px'
        }
        state.wsHeight = `calc(${state.invHeight} - 136px)`
        state.emMfmTableHeight = `calc(${state.meterHeight} - 53px)`
        state.invTableHeight = `calc(${state.invHeight} - 53px)`
        state.wsTableHeight = `calc(${state.wsHeight} - 53px)`
      }
    );

    return {
      ...toRefs(state),
      onResized
    };
  },
  async mounted() {
    this.invHeight = this.isWsAvailable && this.isScbAvailable ? '502px' : '734px'
    this.invTableHeight = `calc(${this.invHeight} - 53px)`
    this.wsHeight = `calc(${this.invHeight} - 136px)`
    this.wsTableHeight = `calc(${this.wsHeight} - 53px)`
    await this.loadDeviceMaps();
  },
  beforeDestroy() {
    this.deviceMapRequestId += 1;
  },
  methods: {
    isDeviceMapRequestCurrent(requestId, plantId) {
      return requestId === this.deviceMapRequestId &&
        String(plantId) === String(this.getSelectedPlantId);
    },
    async loadDeviceMaps() {
      const plantId = this.getSelectedPlantId;
      const requestId = ++this.deviceMapRequestId;

      // Unmount device tables until both maps belong to the same plant.
      this.parameterNameMap = {};
      this.deviceNameMap = {};
      if (!plantId) return;

      const payload = {
        plantId,
        deviceList: this.availableDeviceList.map(deviceName => deviceName.toLowerCase()),
      };

      try {
        const [parameterResponse, deviceResponse] = await Promise.all([
          LiveDb.getParameterMapConfig(payload),
          LiveDb.getDeviceIdMap(payload),
        ]);

        if (!this.isDeviceMapRequestCurrent(requestId, plantId)) return;

        // Set names first because parameterNameMap controls child mounting.
        this.deviceNameMap = deviceResponse.data || {};
        this.parameterNameMap = parameterResponse.data.message || {};
      } catch (error) {
        if (this.isDeviceMapRequestCurrent(requestId, plantId)) {
          console.error("Error loading Live Dashboard device configuration", error);
        }
      }
    }
  },
  watch: {
    async getSelectedPlantId() {
      const deviceMapsPromise = this.loadDeviceMaps();

      // Resetting the pane resizer to normal
      const topContainer = document.querySelector('.top-container')
      if (topContainer) topContainer.style.removeProperty('height')
      this.invHeight = this.isWsAvailable && this.isScbAvailable ? '502px' : '734px'
      this.invTableHeight = `calc(${this.invHeight} - 53px)`
      this.wsHeight = `calc(${this.invHeight} - 160px)`
      this.wsTableHeight = `calc(${this.wsHeight} - 53px)`
      await deviceMapsPromise;
    },
  },
  filters: {
    checkEmpty(value) {
      return typeof value !== "number" ? 0 : value;
    }
  }
};
</script>

<style>
.flex-pane {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.inner-multipane > .multipane-resizer {
  margin: 0 !important;
  top: 0 !important;
  left: 0 !important;
  height: auto !important;
  width: 5px !important;
  border: none !important;
  cursor: ew-resize !important;
  z-index: 10;
}

.theme--dark .inner-multipane > .multipane-resizer {
  background-color: transparent;
  border-left: 1px dashed rgba(255, 255, 255, 0.2) !important;
}

.theme--light .inner-multipane > .multipane-resizer {
  background-color: transparent;
  border-left: 1px dashed rgba(0, 0, 0, 0.2) !important;
}

.inner-multipane > .multipane-resizer:hover {
  background-color: rgba(65, 124, 222, 0.5) !important;
}

.multipane-resizer {
  margin: -1px auto 1px auto; 
  top: 10; 
  height: 5px;
  width: 100px;
}

.theme--dark .multipane-resizer {
	border-top: 0.5px solid #fff;
  border-bottom: 0.5px solid #fff;
}

.theme--light .multipane-resizer {
	border: 0.5px solid #747D8C;
}

.multipane-resizer:hover {
  cursor: ns-resize;
}

.horizontal-resizer {
  margin: 0 auto !important;
  top: 0 !important;
  left: 0 !important;
  height: 5px !important;
  width: 100% !important;
  border: none !important;
  cursor: ns-resize !important;
  background-color: transparent !important;
  z-index: 10;
}

.theme--dark .horizontal-resizer {
  border-top: 1px dashed rgba(255, 255, 255, 0.2) !important;
}

.theme--light .horizontal-resizer {
  border-top: 1px dashed rgba(0, 0, 0, 0.2) !important;
}

.horizontal-resizer:hover {
  background-color: rgba(65, 124, 222, 0.5) !important;
  cursor: ns-resize !important;
}

</style>
